var map = {
	"./PM_2.2.2.png": 47543,
	"./PM_2.3.2.png": 6109,
	"./PM_3.2.2.png": 82355,
	"components/Catalog/P/img/glass/pr/prPlusPerGold/PM_2.2.2.png": 47543,
	"components/Catalog/P/img/glass/pr/prPlusPerGold/PM_2.3.2.png": 6109,
	"components/Catalog/P/img/glass/pr/prPlusPerGold/PM_3.2.2.png": 82355
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 42393;